import { Routes } from '@angular/router';
import { AuthGuard } from './pipes/auth.guard.pipes';

import { WelcomeComponent } from './components/welcome/welcome';
import { ReportViewer } from './components/report-viewer/report-viewer';

import { RedirectComponent } from './components/redirect/redirect';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized';
import { LoginCallbackComponent } from './components/login-callback/login-callback';

export const routes: Routes = [
  { path: '', component: WelcomeComponent, pathMatch: 'full', canActivate: [AuthGuard] },
  { path: 'reports/:name', component: ReportViewer, canActivate: [AuthGuard] },
  { path: 'redirect/suiteedge', component: RedirectComponent },
  { path: 'redirect/imperia', component: RedirectComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'login-callback', component: LoginCallbackComponent },
];
